import Model from "./base/model";

class SimulationAdvalorem extends Model {
  resourceName() {
    return "simulation_advalorem";
  }

  fields() {
    return {
      simulation_table_id: "",
      state_id: "",
      percentage: "",

      simulation_table: {jsonApi: "hasOne", type: "simulation_tables"},
      state: {jsonApi: "hasOne", type: "states"},

    };
  }
}

export default new SimulationAdvalorem();
